export const brazilCenterCoords = { lat: -15.77972, lng: -47.92972 }
